document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('TcgCartDrawer');
    if (!drawer || drawer.dataset.initialized) return;
    drawer.dataset.initialized = 'true';
    var content = drawer.querySelector('[data-tcg-cart-content]');
    var status = drawer.querySelector('[data-tcg-cart-status]');
    var panel = drawer.querySelector('.tcg-cart-drawer__panel');
    var lastFocus;
    var cartUrl = drawer.dataset.cartUrl;
    var addUrl = drawer.dataset.addUrl;
    var changeUrl = drawer.dataset.changeUrl;
    var pending = false;

    function setCounts(count) {
      document.querySelectorAll('[data-tcg-cart-count]').forEach(function (node) { node.textContent = count; });
    }

    function setBusy(busy, message) {
      drawer.classList.toggle('is-busy', busy);
      content.setAttribute('aria-busy', busy ? 'true' : 'false');
      status.textContent = message || '';
    }

    function drawerFocusable() {
      if (!panel) return [];
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (node) { return node.getAttribute('aria-hidden') !== 'true'; }
      );
    }

    function openDrawer(trigger, shouldRefresh) {
      lastFocus = trigger || document.activeElement;
      var mobileMenu = document.getElementById('TcgMobileMenu');
      var mobileToggle = document.querySelector('.tcg-mobile-menu-toggle');
      if (mobileMenu && mobileMenu.contains(lastFocus) && mobileToggle) lastFocus = mobileToggle;
      document.dispatchEvent(new CustomEvent('tcg:menu:close', { detail: { restoreFocus: false } }));
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tcg-cart-drawer-open');
      window.requestAnimationFrame(function () {
        var close = drawer.querySelector('.tcg-cart-drawer__header [data-tcg-cart-close]');
        if (close) close.focus();
      });
      if (shouldRefresh !== false) refreshCart();
    }

    function closeDrawer() {
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tcg-cart-drawer-open');
      status.textContent = '';
      if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus();
    }

    function renderCart(html) {
      if (!html) throw new Error('Missing cart section');
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var rendered = parsed.querySelector('[data-sc-cart-render]');
      if (!rendered) throw new Error('Invalid cart section');
      content.replaceChildren(...rendered.childNodes);
      setCounts(Number(rendered.dataset.itemCount));
    }

    function refreshCart(message) {
      if (pending) return Promise.resolve();
      pending = true;
      setBusy(true, message || 'Updating cart…');
      return fetch(cartUrl + '?section_id=sc-cart-drawer-content', { headers: { Accept: 'text/html' }, cache: 'no-store' })
        .then(function (response) { if (!response.ok) throw new Error('Unable to load cart'); return response.text(); })
        .then(function (html) { renderCart(html); setBusy(false, message || ''); })
        .catch(function () { setBusy(false, 'Unable to load current cart details. Please use the full cart page.'); content.replaceChildren(); var fallback = document.createElement('a'); fallback.href = cartUrl; fallback.textContent = 'View full cart'; content.appendChild(fallback); })
        .finally(function () { pending = false; });
    }

    function changeLine(key, quantity) {
      if (pending) return;
      pending = true;
      setBusy(true, 'Updating cart…');
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Number(quantity), sections: ['sc-cart-drawer-content'], sections_url: cartUrl })
      })
        .then(function (response) { return response.json().then(function (cart) { if (!response.ok) throw new Error(cart.description || 'Unable to update item'); return cart; }); })
        .then(function (cart) {
          setCounts(cart.item_count);
          var html = cart.sections && cart.sections['sc-cart-drawer-content'];
          if (!html) { pending = false; return refreshCart(); }
          renderCart(html);
          setBusy(false, Number(quantity) === 0 ? 'Item removed.' : 'Quantity updated.');
        })
        .catch(function () { pending = false; return refreshCart('Please check the current quantity before trying again.'); })
        .finally(function () { pending = false; });
    }

    document.querySelectorAll('[data-tcg-cart-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) { event.preventDefault(); openDrawer(trigger); });
    });
    drawer.querySelectorAll('[data-tcg-cart-close]').forEach(function (button) { button.addEventListener('click', closeDrawer); });
    content.addEventListener('click', function (event) {
      var button = event.target.closest('[data-tcg-cart-key]');
      if (button && !button.disabled) changeLine(button.dataset.tcgCartKey, button.dataset.tcgCartQuantity);
    });
    document.addEventListener('keydown', function (event) {
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = drawerFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var activeInside = panel && panel.contains(document.activeElement);
      if (event.shiftKey && (!activeInside || document.activeElement === first)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (!activeInside || document.activeElement === last)) {
        event.preventDefault();
        first.focus();
      }
    });

    var productForm = document.getElementById('TcgProductForm');
    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = productForm.querySelector('[type="submit"]');
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        var formData = new FormData(productForm);
        var quantityInput = productForm.querySelector('[name="quantity"]');
        var variantSelect = productForm.querySelector('select[name="id"]');
        var option = variantSelect && variantSelect.options[variantSelect.selectedIndex];
        var limitValue = option ? option.dataset.quantityLimit : quantityInput.dataset.initialLimit;
        var note = document.getElementById('ScStockLimit');
        var check = Promise.resolve();
        if (limitValue !== '' && limitValue != null) {
          check = fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
            .then(function (response) { if (!response.ok) throw new Error('Unable to check your current cart. Please try again.'); return response.json(); })
            .then(function (cart) {
              var inCart = cart.items.reduce(function (sum, item) { return sum + (String(item.variant_id) === String(formData.get('id')) ? item.quantity : 0); }, 0);
              if (inCart + Number(formData.get('quantity')) > Number(limitValue)) {
                var message = note.dataset.cartLimit.replace('__COUNT__', limitValue).replace('__CART__', inCart);
                note.hidden = false;
                note.textContent = message;
                var error = new Error(message);
                error.stockLimit = true;
                throw error;
              }
            });
        }
        check.then(function () { return fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData }); })
          .then(function (response) { return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Unable to add item'); return data; }); })
          .then(function () { openDrawer(button, false); return refreshCart('Added to your cart.'); })
          .catch(function (error) { if (error.stockLimit) { quantityInput.focus(); return; } openDrawer(button, false); setBusy(false, error.message); })
          .finally(function () { button.disabled = false; button.textContent = originalText; });
      });
    }
  });
